module.exports = __webpack_public_path__ + "img/2025-11-17b_2.9a0af1ed.jpg";